import React from 'react';

function PrivacyIcon({ className = '' }) {
	return (
		<svg
			className={className}
			width='32'
			height='32'
			viewBox='0 0 32 32'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d='M16 4.2535L25.3333 8.40016V14.6668C25.3333 20.6935 21.36 26.2535 16 27.9068C10.64 26.2535 6.66667 20.6935 6.66667 14.6668V8.40016L16 4.2535ZM16 1.3335L4 6.66683V14.6668C4 22.0668 9.12 28.9868 16 30.6668C22.88 28.9868 28 22.0668 28 14.6668V6.66683L16 1.3335ZM14.6667 9.3335H17.3333V12.0002H14.6667V9.3335ZM14.6667 14.6668H17.3333V22.6668H14.6667V14.6668Z'
				fill='#323232'
			/>
		</svg>
	);
}

export default PrivacyIcon;
